import Modal from '../lib/Modal';
import Close from '../lib/Close';

const trigger = document.querySelectorAll('.js-modal-trigger2');

const modalHTML = `
<div class="v1-dialog2" id="js-modal2">
  <div class="v1-dialog2__content" id="js-modal-focus2" role="dialog" aria-modal="true" tabindex="-1">
    <div class="v1-dialog2__inner">
      <div class="v1-dialog2__cloneContent" id="js-modal-content2"></div>
      <div class="v1-dialog2__footActions">
        <button type="button" class="js-modal-close2 v1-button v1-dialog2__button">${Close.text()}</button>
      </div>
    </div>
  </div>
  <div class="v1-dialog2__overlay" id="js-modal-overlay2"></div>
</div>
`;

export default function v1Dialog() {
  window.addEventListener('DOMContentLoaded', () => {
    if (trigger.length) {
      document.getElementsByTagName('body')[0].insertAdjacentHTML('beforeend', modalHTML);
    }
  });

  window.addEventListener('load', () => {
    if (trigger.length) {
      const modal = new Modal({
        trigger: '.js-modal-trigger2',
        cloneContent: '.js-modal-clone2',
        closeButton: '.js-modal-close2',
        modal: 'js-modal2',
        content: 'js-modal-content2',
        focus: 'js-modal-focus2',
        overlay: 'js-modal-overlay2',
      });
      modal.init();
    }
  });
}
